import { useQuery } from '@tanstack/react-query'
import { scopeApi } from '../api/scopeApi'

export function usePendingProposalsCounts() {
  return useQuery({
    queryKey: ['scope-proposals-pending-counts'],
    queryFn: () => scopeApi.getPendingProposalsCounts().then(r => r.data),
    refetchInterval: 30_000,
    staleTime: 15_000,
  })
}
